import { createContext, useContext } from "react";
import type { ModalMap } from "./modalTypes";

type ModalContextType = {
  openModal: <K extends keyof ModalMap>(name: K, props: ModalMap[K]) => void;

  closeModal: () => void;
};

export const ModalContext = createContext<ModalContextType | null>(null);

export function useModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) {
    throw new Error("useModal must be used inside ModalProvider");
  }
  return ctx;
}
